<template lang="pug">
  div
    demo-modal(
      v-if="demoType!=null"
      :visibleProp="showDemoModal"
      @close="showDemoModal = false; demoType = null"
      :type="demoType"
    )

    div(class="feature-carousel-container" style="position: relative;")
      h2 MathSmith App Features
      el-carousel(class="feature-carousel" arrow="always" :interval="8000" :loop="!showDemoModal"  indicator-position="outside")
        el-carousel-item(v-for="item in demoKeys" :key="item")
          div(class="feature-carousel-item")
            el-row(class="padded-vertical")
              el-col(:span="22")
                h3(class="small") {{ demoItems[item].title }}
                
                el-row.margin-top-15(style="display: flex; flex-direction: row; justify-content: flex-start; gap: 20px;" class="carousel-holder")
                  el-col(:span="4" class="carousel-icon")
                    img(
                      v-for="icon in demoItems[item].icons"  
                      :class="{'mini-logo': demoItems[item].icons.length == 1, 'mini-logo-multiple':demoItems[item].icons.length > 1}"
                      :src="require(`@/assets/icons/${icon}`)")
                  el-col(:span="20" class="carousel-description")
                    div(v-html="demoItems[item].desc")
            a(
              v-if="!demoItems[item].noDemo"
              class="btn btn-primary demo-button"
              @click.prevent.stop="showDemo(item)"
            ) Try Demo

            a(
              v-else-if="demoItems[item].scroll != undefined"
              class="btn btn-primary demo-button"
              @click.prevent.stop="scrollToElement(demoItems[item].scroll.id)"
            ) {{ demoItems[item].scroll.text }}

            a(
              v-else-if="demoItems[item].link != undefined"
              class="btn btn-primary demo-button"
              :href="demoItems[item].link.url"
              target="_blank"
            ) {{ demoItems[item].link.text }}
</template>

<script>
import DemoModal from "@/components/demo/DemoModal";
import demoOverview from "@/defines/demo/demo-overview";
import { DEMO_TYPES } from "@/defines/constants";

export default {
  name: "Features",

  components: {
    DemoModal
  },

  data() {
    return {
      demoType: "",
      showDemoModal: false,
      demoKeys: DEMO_TYPES,
      demoItems: demoOverview
    };
  },

  methods: {
    showDemo(type) {
      this.demoType = type;
      this.showDemoModal = true;
    },

    scrollToElement(id) {
      const el = document.getElementById(id);
      el.scrollIntoView({ behavior: "smooth" });
    }
  }
};
</script>
